import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import api from "../services/api";
import "./Login.css";
import AccountHomeButton from "../pages/Auth/account-home-button";

const Login = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "", remember: false });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

 

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
  };

  const validate = () => {
    const e = {};
    if (!form.email) e.email = "Please enter your email";
    else if (!/^\S+@\S+\.\S+$/.test(form.email)) e.email = "Invalid email";
    if (!form.password) e.password = "Please enter your password";
    else if (form.password.length < 6) e.password = "Password must be at least 6 characters";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const onSubmit = async (evt) => {
    evt.preventDefault();
    if (!validate()) return;
    setSubmitting(true);
    try {
      const { data } = await api.post("/login", {
        email: form.email,
        password: form.password,
        remember: form.remember,
      });
      if (data.accessToken) {
        api.defaults.headers.common["Authorization"] = `Bearer ${data.accessToken}`;
        navigate("/dashboard/business/user/profile");
      } else {
        navigate("/otp", { state: { userId: data.userId } });
      }
    } catch {
      alert("Login failed.");
    } finally {
      setSubmitting(false);
    }
  };

 
 

  return (
    <React.Fragment>
      <AccountHomeButton />
    <div className="log-page">
      {/* LEFT SIDE */}
      <div className="log-left">
     
        <div className="log-left-inner">
         
          <h1 className="log-title">Log in</h1>
         

          <form className="log-form" onSubmit={onSubmit} noValidate>
            {/* Email */}
            <label className="log-label" htmlFor="email">Email</label>
            <input
              className={`log-input ${errors.email ? "log-input-error" : ""}`}
              type="email"
              id="email"
              name="email"
              placeholder="hello@skyline.com"
              value={form.email}
              onChange={onChange}
              autoComplete="email"
            />
            {errors.email && <div className="log-error">{errors.email}</div>}

            {/* Password */}
            <label className="log-label" htmlFor="password">Password</label>
            <div className="log-password-wrap">
              <input
                className={`log-input log-password-input ${errors.password ? "log-input-error" : ""}`}
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                placeholder="Enter your password"
                value={form.password}
                onChange={onChange}
                autoComplete="current-password"
              />
              <button
                type="button"
                className="log-eye"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            {errors.password && <div className="log-error">{errors.password}</div>}

            <div className="log-row-between">
              <label className="log-remember">
                <input
                  type="checkbox"
                  name="remember"
                  checked={form.remember}
                  onChange={onChange}
                />
                <span>Remember me</span>
              </label>
              <Link to="/forgotpassword" className="log-link">Forgot password?</Link>
            </div>

            <button className="log-submit" type="submit" disabled={submitting}>
              {submitting ? "Logging in…" : "Log in"}
            </button>

            <button
              type="button"
              className="log-link-btn"
              onClick={() => navigate("/bus-login")}
            >
              Business staff login
            </button>
          </form>
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="log-right">
        <div className="log-quote">
          <div className="log-quote-mark">“</div>
          <h1 className="log-title-right">Welcome back</h1>
<p>Let’s get back to business.</p>

        </div>
        <div className="log-dashboard-shell" role="img" aria-label="Dashboard screenshot placeholder">
          <img
  src="/dash.png"
  alt="Payweek Logo"
  className="logo--light"
/>

{/* Dark logo */}
<img
  src="/dashdark.png"
  alt="Payweek Logo"
  className="logo--dark"
/>
        </div>
      </div>
    </div>
    </React.Fragment>
  );
};

export default Login;

// import React, {useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import api from "../services/api";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   CardBody,
//   Button,
//   Label,
//   Input,
//   Form,
//   FormFeedback,
// } from "reactstrap";

// // Formik validation
// import * as Yup from "yup";
// import { useFormik } from "formik";

// // Import Home import AccountHomeButton 
// import AccountHomeButton from "../pages/Auth/account-home-button";



// const Login = () => {
//   const navigate = useNavigate();



//   useEffect(() => {
//     document.body.classList.add("bg-account-pages", "py-4", "py-sm-0");
//     document.getElementById("colorTheme").setAttribute("href", "assets/colors/red.css");

//     return () => {
//       document.body.classList.remove("bg-account-pages", "py-4", "py-sm-0");
//       document.getElementById("colorTheme").setAttribute("href", "assets/colors/cyan.css");
//     };
//   }, []);

//   const validation = useFormik({
//     enableReinitialize: true,
//     initialValues: {
//       email: "",
//       password: "",
//     },
//     validationSchema: Yup.object({
//       email: Yup.string().email("Invalid email").required("Please Enter Your Email"),
//       password: Yup.string().min(6, "Password must be at least 6 characters").required("Please Enter Your Password"),
//     }),
    
//     onSubmit: async (values, { setSubmitting }) => {
//      setSubmitting(true);  
//       try {
//         const { data } = await api.post("/login", values);

//         if (data.accessToken) {
//           api.defaults.headers.common["Authorization"] = `Bearer ${data.accessToken}`;
//           navigate("/dashboard/business/user/profile");
//         } else {
//           alert(data.message);
//           navigate("/otp", { state: { userId: data.userId } });
//         }
//       } catch (err) {
//         alert("Login failed.");
//              } finally {
//        setSubmitting(false);
//       }
//     },
//   });

//   return (
//     <React.Fragment>
//       {/* Home Button */}
//       <AccountHomeButton />

     

//       <section className="vh-100">
//         <div className="display-table">
//           <div className="display-table-cell">
//             <Container>
//               <Row className="justify-content-center">
//                 <Col lg="5">
//                   <Card className="account-card">
//                     <CardBody>
//                       <div className="text-center mt-3">
//                         <h3 className="font-weight-bold">
//                           <Link to="/" className="text-dark text-uppercase account-pages-logo">
//                             <i className="mdi"></i> PAYWEEK
//                           </Link>
//                         </h3>
//                         <p className="text-muted">Sign in to continue.</p>
//                       </div>
//                       <div className="p-4">
//                         <Form onSubmit={validation.handleSubmit}>
//                           <div className="form-group">
//                             <Label for="email">Email</Label>
//                             <Input
//                               name="email"
//                               placeholder="Enter Email"
//                               type="email"
//                               onChange={validation.handleChange}
//                               onBlur={validation.handleBlur}
//                               value={validation.values.email || ""}
//                               invalid={validation.touched.email && validation.errors.email ? true : false}
//                             />
//                             {validation.touched.email && validation.errors.email ? (
//                               <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
//                             ) : null}
//                           </div>

//                           <div className="form-group mt-3">
//                             <Label for="password">Password</Label>
//                             <Input
//                               name="password"
//                               placeholder="Enter password"
//                               type="password"
//                               onChange={validation.handleChange}
//                               onBlur={validation.handleBlur}
//                               value={validation.values.password || ""}
//                               invalid={validation.touched.password && validation.errors.password ? true : false}
//                             />
//                             {validation.touched.password && validation.errors.password ? (
//                               <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
//                             ) : null}
//                           </div>

//                           <div className="custom-control custom-checkbox mt-2">
//                             <Input type="checkbox" className="custom-control-input" id="customControlInline" />{" "}
//                             <Label className="custom-control-label" for="customControlInline">
//                               &nbsp;Remember me
//                             </Label>
//                           </div>

//                           <div className="d-grid mt-3">
//                              <Button type="submit" className="login-btn" disabled={validation.isSubmitting}>
//                           {validation.isSubmitting ? "Logging in…" : "Log In"}
//                             </Button>
//                           </div>

//                           <div className="mt-4 mb-0 text-center">
//                             <Link to="/forgotpassword" className="text-dark">
//                               <i className="mdi mdi-lock"></i> Forgot your password?
//                             </Link>
//                           </div>
//                           <div>
//                                                   <Button
//                                                     color="link"
//                                                     className="text-primary"
//                                                     onClick={() => navigate("/bus-login")}
//                                                   >
//                                                     Business Staff Login
//                                                   </Button>
//                                                 </div>
//                         </Form>
//                       </div>
//                     </CardBody>
//                   </Card>
//                 </Col>
//               </Row>
//             </Container>
//           </div>
//         </div>
//       </section>
//     </React.Fragment>
//   );
// };

// export default Login;





// import React, { useState } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import api from "../services/api";

// const Login = () => {
//     const [loginData, setLoginData] = useState({ email: "", password: "" });
//     const navigate = useNavigate();

//     const handleLoginChange = (e) => {
//         const { name, value } = e.target;
//         setLoginData((prevData) => ({ ...prevData, [name]: value }));
//     };

//     const handleLoginSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const { data } = await api.post("/login", loginData);

//             if (data.accessToken) {
//                 api.defaults.headers.common["Authorization"] = `Bearer ${data.accessToken}`;
//                 alert("Logged in successfully!");
//                 navigate("/dashboard/business/user/profile");
//             } else {
//                 alert(data.message);
//                 navigate("/otp", { state: { userId: data.userId } });
//             }
//         } catch (err) {
//             alert("Login failed.");
//         }
//     };

//     return (
//         <form onSubmit={handleLoginSubmit}>
//             <label htmlFor="chk">Login</label>
//             <input
//                 type="email"
//                 name="email"
//                 placeholder="Email"
//                 value={loginData.email}
//                 onChange={handleLoginChange}
//                 required
//             />
//             <input
//                 type="password"
//                 name="password"
//                 placeholder="Password"
//                 value={loginData.password}
//                 onChange={handleLoginChange}
//                 required
//             />
//             <Link to="/forgotpassword">Forgot password?</Link>
//             <button type="submit">Login</button>
//         </form>
//     );
// };

// export default Login;



// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import api from "../services/api";
// //import "./Styles.css";

// const Login = () => {
//     const [form, setForm] = useState({ email: "", password: "" });
//     const navigate = useNavigate();

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setForm((prevForm) => ({ ...prevForm, [name]: value }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         try {
//             const { data } = await api.post("/login", form);
//             if (data.accessToken) {
//                 api.defaults.headers.common["Authorization"] = `Bearer ${data.accessToken}`;
//                 alert("Logged in successfully!");
//                 navigate("/dashboard");
//             } else {
//                 alert(data.message);
//                 navigate("/otp", { state: { userId: data.userId } });
//             }
//         } catch (err) {
//             alert("Login failed.");
//         }
//     };

//     return (
//         <div className="main">
//             <div className="login">
//                 <form onSubmit={handleSubmit}>
//                     <label for="chk" aria-hidden="true">Login</label>
//                     <input name="email" placeholder="Email" onChange={handleChange} required />
//                     <input name="password" placeholder="Password" type="password" onChange={handleChange} required />
//                     <button type="submit">Login</button>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default Login;




// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import api from "../services/api";
// import "./Login.css";
// import { Link } from "react-router-dom";

// const Login = () => {
//     const [showForm, setShowForm] = useState(false); // State to toggle form visibility
//     const [form, setForm] = useState({ email: "", password: "" });
//     const navigate = useNavigate();

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setForm((prevForm) => ({ ...prevForm, [name]: value }));
//     };


//     const handleSubmit = async (e) => {
//         e.preventDefault();
    
//         try {
//             const { data } = await api.post("/login", form);
    
//             if (data.accessToken) {
//                 // Store access token in memory
//                 api.defaults.headers.common["Authorization"] = `Bearer ${data.accessToken}`;
//                 alert("Logged in successfully!");
    
//                 // Redirect to dashboard
//                 navigate("/dashboard");
//             } else {
//                 // Redirect to OTP verification
//                 alert(data.message);
//                 navigate("/otp", { state: { userId: data.userId } });
//             }
//         } catch (err) {
//             console.error("Login error:", err.response?.data || err.message);
//             alert(err.response?.data || "Login failed. Please try again.");
//         }
//     };
    
//     return (
         
//         <div className="container">
//             <div
//                 id="log"
//                 onClick={() => setShowForm(true)} // Show the form when clicked
//                 style={{ cursor: "pointer", marginBottom: "10px" }}
//             >
//                 Login
//             </div>
//             <div
//             id="reg"
//             onClick={() => navigate("/register")}
//             style={{
//             cursor: "pointer"
//             }}
//             >
//             Register
//             </div>
            

        
        
//             {showForm && (
//             <form className="logForm" onSubmit={handleSubmit}>
//                 <input name="email" placeholder="Email" id="emailAdd" onChange={handleChange} required />
        
//                 <input name="password" placeholder="Password" type="password" id="pass" onChange={handleChange} required />
//                 <button type="submit">Login</button>
//                 <Link to="/forgotpassword" style={{ marginTop: "3px", cursor: "pointer", color: "white"}}>forgot password?</Link>
//             </form>
//             )}
//             <Link to="/register" style={{ marginTop: "10px", cursor: "pointer", textDecoration: "underline", color: "blue" }}>
//     Register
// </Link>
//         </div>
            
        
//     );
// };

// export default Login;
